import React, { useEffect, useState } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import "../css/main.css";
import { getProfile } from "../redux/action";

function Profile() {
  const { data, loading, error } = useSelector((state) => state.Profile);
  const dispatch = useDispatch();
  const get = data.user ?? false;
  useEffect(() => {
    dispatch(getProfile());
    setTimeout(() => {
      if (data) {
        localStorage.setItem("User", JSON.stringify(data?.user));
      }
    }, 2000);
  }, []);
  //////////////////////////////////////////////////////////////   get localStorage
  const storageUser = JSON.parse(localStorage.getItem("User"));
  //////////////////////////////////////////////////////////////
  return (
    <div className="w-full flex justify-center">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full sm:w-4/6 lg:w-3/6 2xl:w-2/6">
          <div className="card w-full bg-primary text-primary-content mt-32 sm:mt-32 shadow-lg">
            <div className="card-body">
              <div className="avatar mb-10 flex justify-center transition duration-700">
                <div className="w-24 rounded-full ring ring-black hover:scale-125 hover:ring-red-900 ring-offset-base-100 ring-offset-2 transition duration-700">
                  <img src={get.image ? get.image : storageUser.image} />
                </div>
              </div>
              <div className="block">
                <div className="flex justify-start mb-5">
                  <label>User Name : </label>
                  <label className="ml-2">
                    {get.username ? get.username : storageUser.username}
                  </label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>Email : </label>
                  <label className="ml-2">
                    {get.email ? get.email : storageUser.email}
                  </label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>Mobile : </label>
                  <label className="ml-2">{get ? get.mobile : ""}</label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>First Name : </label>
                  <label className="ml-2">{get ? get.firstname : ""}</label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>Last Name : </label>
                  <label className="ml-2">{get ? get.lastname : ""}</label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>Gender : </label>
                  <label className="ml-2">{get ? get.gender : ""}</label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>Age : </label>
                  <label className="ml-2">{get ? get.age : ""}</label>
                </div>
                <div className="flex justify-start mb-5">
                  <label>City : </label>
                  <label className="ml-2">{get ? get.city : ""}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
